export default __webpack_public_path__ + "static/media/map-mobile.b2b00f93.webp";